import classNames from "classnames"
import { useAudienceVisitorsTableMapState } from "./AudienceVisitorsTableMapState";
import { formatValue } from "@/migrated-widgets/table-map/utils/random";

export const TableFooter = () => {
    const { totals, zipCodes, audiencesIds, makeIds, modelIds, groupIds } = useAudienceVisitorsTableMapState();

    const hasFilters = zipCodes.length || audiencesIds.length || groupIds.length || makeIds.length || modelIds.length;

    return (
        <div className={classNames('flex', 'justify-between', 'items-center', 'w-full', 'px-10', 'py-3', 'border-b', 'border-b-table-map-lightGray', 'gap-2', 'hover:backdrop-brightness-95', 'font-bold', {
            'bg-table-map-teal': !hasFilters,
            'cursor-pointer': !zipCodes.length
        })}>
            <div className={classNames('flex', 'items-center', 'gap-1', 'text-sm', 'tracking-[-0.15]', 'text-left', 'text-brand-black', 'basis-13/20')}>
                Total
            </div>
            <div className={classNames('flex', 'items-center', 'gap-1', 'text-sm', 'tracking-[-0.15]', 'text-left', 'text-brand-black', '!basis-7/20', 'justify-center')}>
                {formatValue(totals.totalVisitors)}
            </div>
        </div>
    )
}
